import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface ISelectedSidepanelState {
    sidepanelName: string | null;
    thumbnailSize: number | null;
}

export const selectedSidepanelSlice = createSlice({
    name: 'selectedSidepanel',
    initialState: { sidepanelName: null, thumbnailSize: 3 } as ISelectedSidepanelState,
    reducers: {
        changeSidepanelName: (state, action: PayloadAction<string | null>) => {
            state.sidepanelName = action.payload;
        },
        setThumbnailSize: (state, action: PayloadAction<number | null>) => {
            state.thumbnailSize = action.payload;
        },
    },
});

export const { changeSidepanelName, setThumbnailSize } = selectedSidepanelSlice.actions;
export const selectedSidepanelName = (state: IGlobalStoreReducers) =>
    state.selectedSidepanel.sidepanelName;
export const thumbnailSize = (state: IGlobalStoreReducers) => state.selectedSidepanel.thumbnailSize;

export default selectedSidepanelSlice.reducer;
